import { z } from 'zod'

export const uploadDatasetSchema = z.object({
  name: z.string().min(1, 'Dataset name is required').max(100, 'Dataset name must be less than 100 characters'),
  symbol: z.string().max(50).optional().or(z.literal('')),
  timeframe: z.string().max(20).optional().or(z.literal('')),
})

export type UploadDatasetInput = z.infer<typeof uploadDatasetSchema>

// File validation is done separately
export function validateFile(file: File | null): string | null {
  if (!file) {
    return 'File is required'
  }
  if (file.size > 100 * 1024 * 1024) {
    return 'File size must be less than 100MB'
  }
  if (file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
    return 'File must be a CSV file'
  }
  return null
}
